const messageSelector = '.cl-form__message';
const messageShowClass = 'cl-form__message--show';

function initCardSlider(elementSelector, navSelector) {
    const element = $(elementSelector);
    const slidesToShow = 3;

    if (!element.hasClass('slick-initialized')) {
        const slickOptions = {
            dots: true,
            infinite: false,
            autoplay: false,
            slidesToShow,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false
                    }
                }
            ]
        };

        if (navSelector) {
            slickOptions.prevArrow = navSelector + ' .cl-carousel-button--left';
            slickOptions.nextArrow = navSelector + ' .cl-carousel-button--right';
        }

        element.slick(slickOptions);

        if (areAllSlidesShown(element, slidesToShow)) {
            refreshSlickOnWindowResize(element)
        }
    }
}

function areAllSlidesShown(element, slidesToShow) {
    let allSlidesShown = false;
    const slideCount = element.find('.cl-card-variants__container.slick-slide').length;

    if (slidesToShow === slideCount) {
        allSlidesShown = true;
    }

    return allSlidesShown;
}

function refreshSlickOnWindowResize(element) {
    let windowResizeTimeoutId;

    $(window).resize(function () {
        clearTimeout(windowResizeTimeoutId);
        windowResizeTimeoutId = setTimeout(function () {
            element[0].slick.refresh();
        }, 100);
    });
}

function initColorSelectorCarousels() {
    const colorSelectors = $('.cl-card__colors');

    colorSelectors.each(function () {
        const colorSelector = $(this);

        if (!colorSelector.hasClass('slick-initialized')) {
            initColorSelectorCarousel(colorSelector);

            colorSelector.on('afterChange', function (e, slick, nextSlide) {
                const variantsContainer = colorSelector.parents('[class^=cl-card-variants__container]');
                const siblingColorSelectors = variantsContainer.find('.cl-card__colors');

                siblingColorSelectors.each(function () {
                    const siblingColorSelector = $(this);

                    if (siblingColorSelector.slick('slickCurrentSlide') !== nextSlide) {
                        siblingColorSelector.slick('slickGoTo', nextSlide);
                    }
                });
            });
        }
    });

    switchCardOnColorSelector();
}

function initColorSelectorCarousel(colorSelector) {
    colorSelector.slick({
        dots: false,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        prevArrow: '',
        nextArrow: '<i class="cl-icon cl-chevron-right"></i>',
        responsive: [
            {
                breakpoint: Infinity,
                settings: {
                    slidesToShow: getSlidesToShowCount('desktop'),
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: getSlidesToShowCount('mobile'),
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function switchCardOnColorSelector() {
    $('[class^=cl-color]').on('click touch', function () {
        const selectedVariant = $(this);
        const container = selectedVariant.parents('[class^=cl-card-variants__container]');
        const selectedHandle = selectedVariant.attr('data-handle');
        const childrenToHide = container.children('[class^=cl-product-card]');
        const childrenToShow = container.children('[class^=cl-product-card][data-handle=' + selectedHandle + ']');

        childrenToHide && childrenToHide.hide();

        selectedHandle && childrenToShow && childrenToShow.show();
    })
}

function getSlidesToShowCount(size = 'desktop') {
    let visibleCardsCount = 3;
    const singleColorSelectorWidth = 24;
    const gap = 8;
    const stepWidth = singleColorSelectorWidth + gap;
    const sectionWidth = $('[class^=cl-section]').width();

    if ('mobile' === size) {
        visibleCardsCount = 1;
    }

    const slidesToShowCount = Math.ceil((sectionWidth / visibleCardsCount) / stepWidth);

    return Math.max(slidesToShowCount, 1);
}

function setClSelect() {
    $('.cl-select--original').minimalect({
        theme: 'cl-select',
        placeholder: '',
        live: true
    })
}

function addSmoothScrollBehavior() {
  $('html').css('scrollBehavior', 'smooth');
}

function addQuickCart(product) {
    const variant = product.attr('data-value');
    const card = product.parents('.cl-product-card');
    const cardDiscounted = product.parents('.cl-product-card--sale');
    let isOnSale = false;
    let isDiscountAppliable = false;

    let title = card.find('.cl-card__title').html();
    let image = card.find('img.cl-card__img-top').attr('src');
    let price = card.find('.cl-card__price').attr('data-price');

    if (cardDiscounted.length) {
        const newPriceElement = cardDiscounted.find('.cl-card__price--new');
        isDiscountAppliable = "true" === newPriceElement.attr('data-discount-appliable');
        const appliablePriceElement = isDiscountAppliable
          ? newPriceElement
          : cardDiscounted.find('.cl-card__price--old');
        price = appliablePriceElement.attr('data-price');
        title = cardDiscounted.find('.cl-card__title').html();
        image = cardDiscounted.find('img.cl-card__img-top').attr('src');
        isOnSale = "true" === newPriceElement.attr('data-on-sale');
    }

    const postData = {
        id: variant,
        quantity: 1,
        properties: {}
    }

    const cartHooverData = {
        price,
        title,
        image,
        qty: 1,
        isDiscountAppliable,
    }

    if (isOnSale) {
        postData['properties']['on_sale'] = true;
    }

    $.ajax({
        url: "/cart/add.js",
        data: postData,
        dataType: "json",
        success: function () {
            updateCartHoover(cartHooverData);
            updateSmallCartIcon();
            showSmallCart();
        }
    })
}

function redirectToProductPage(product)
{
    const variant_id = product.attr('data-value');
    const product_card = product.parents('.cl-product-card__c');
    const product_handle = product_card.attr('data-handle');

    if (variant_id && product_handle) {
        let product_url_with_variant_selected = '/products/' + product_handle + '?variant=' + variant_id;
        window.location.href = product_url_with_variant_selected;
    }
}

function disableClSelectContentEditable(){
    $('.cl-select span').attr('contenteditable', false);
}

function setClLabelSelected() {
    var select = $('.cl-select');
    select.on('click', function () {
        $(this)
            .siblings('.cl-select__label')
            .addClass('cl-select__label--selected')
    })
}

function initComponents() {
    setClSelect();
    disableClSelectContentEditable();
    setClLabelSelected();
    initColorSelectorCarousels();
}

function hideMessages() {
  $(messageSelector).removeClass(messageShowClass);
}

function showMessage(message) {
  message.addClass(messageShowClass);
}

function handleVideoAutoPlay () {
  var screenWidth = $(window).width();
  var productVideos = $('.cl-card__video');

  if (screenWidth >= 768) {
    productVideos.attr('autoplay', 'autoplay');
  } else {
     productVideos.attr('controls', true);
  }
}

$(document).ready(function () {
    initComponents();
    addSmoothScrollBehavior();
    //handleVideoAutoPlay();
})
